module.exports = {
  title: 'xd-map',
  APPID: 'xxx',
  APPSECRET: 'xxx',
  $cdn: 'https://xxx/static'
};